module.exports = __webpack_public_path__ + "static/media/M2.66162457.png";